import Vue from 'vue';
import striptags from 'striptags';
import { fmtAs } from '@/utils/date';
import { truncate } from '@/utils/string';

Vue.filter('fmtAsDate', (date: string) => {
  return fmtAs(date, 'yyyy/MM/dd');
});
Vue.filter('stripHTML', (html: string) => {
  return striptags(html);
});
Vue.filter('truncate', (value, indexEnd, leader) => {
  return truncate(value, indexEnd, leader);
});
